import { ITag } from "@app/interfaces/ITag";
import { ResourceAllocation, ResourceType } from "@enums/ResourceType";
import { TagsService } from "@services/tags.service";
import * as angular from "angular";
import "./tags.scss";

interface ITagsComponentBindings {
    resource: any;
    editMode: boolean;
    max: number;
    onTagDeleted: (args: { tag: ITag }) => void;
}

class TagsComponentController implements angular.IComponentController, ITagsComponentBindings {
    allTags: ITag[] = [];
    assignedTags: ITag[] = [];
    hiddenTags: ITag[] = [];
    resource: any;
    showSelect: boolean = false;
    editMode: boolean = true;
    selectedTag: ITag;

    onChange: () => void;
    onTagDeleted: (args: { tag: ITag }) => void;

    resourceAllocationEnum = ResourceAllocation;

    resourceType: string;

    tooltipLabel: string;
    max: number;

    minLength = 0;

    static $inject = ["$scope", "$timeout", "$mdDialog", "tagsService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $timeout: angular.ITimeoutService,
        private readonly $mdDialog: angular.material.IDialogService,
        private readonly tagsService: TagsService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["resource"]) {
            this.getTags();
        }
    }

    $onDestroy() {
        this.updateTags();
    }

    onGeofenceTagDeleted(tag: ITag): void {
        if (this.onTagDeleted) {
            this.onTagDeleted({ tag });
        }
    }

    addItemToList(tag: ITag) {
        this.assignedTags.push(tag);
        this.updateTags();
    }

    openEditTagsDialog($event: MouseEvent) {
        const controller = ($mdDialog) => {
            return {
                hide: () => { $mdDialog.hide(); },
                onGeofenceTagDeleted: (tag: ITag) => { this.onGeofenceTagDeleted(tag) }
            }
        };
        controller.$inject = ["$mdDialog"];
        const dialogOptions: angular.material.IDialogOptions = {
            targetEvent: $event,
            escapeToClose: true,
            clickOutsideToClose: true,
            multiple: true,
            template: require("../../../main/components/resourceManagement/geofences/geofenceTagsEdit/geofenceTagsEdit.dialog.html"), // Use scope
            controller: controller,
            controllerAs: "$ctrl"
        };

        this.$mdDialog.show(dialogOptions).then(() => {
            this.getTags();
        });
    }

    removeItemFromList(tag: ITag) {
        const index = this.assignedTags.indexOf(tag);

        if (index >= 0) {
            this.assignedTags.splice(index, 1);
        }
        if (this.onChange) {
            this.onChange();
        }
        this.updateTags();
    }

    //searchText: string;
    querySearch(searchText: string) {

        var unselectedTags = this.allTags.filter(tag => this.assignedTags.indexOf(tag) < 0);

        unselectedTags = unselectedTags.filter(tag => !tag.AutoTag);

        if (this.resourceType) {
            unselectedTags = unselectedTags.filter(tag => tag.ResourceAllocation == ResourceAllocation[this.resourceType] || tag.ResourceAllocation == ResourceAllocation.All);
        }

        if (!searchText) {
            return unselectedTags;
        }

        searchText = searchText.toLocaleLowerCase();

        unselectedTags = unselectedTags.filter(tag => tag.Name.toLowerCase().includes(searchText) || ResourceAllocation[tag.ResourceAllocation].toLowerCase().includes(searchText));

        unselectedTags.sort((a, b) => { return a.Position - b.Position });

        return unselectedTags;
    }

    selectedItemChanged(item) {
        this.minLength = 0;

        this.$timeout(() => {
            this.minLength = 0;

            (document.activeElement as HTMLElement).blur();
        }, 500);
        if (this.onChange) {
            this.onChange();
        }
    }

    //------------------------------------------------

    private getTags() {
        this.tagsService
            .getTags()
            .then(tags => {
                // Remove duplicates (from testing), start with auto tags as they should take priority

                tags = this.deDupeTags(tags);

                this.assignedTags = [];

                if (this.resource && this.resource.TagIds) {

                    this.resource.TagIds.forEach(resourceTagId => {
                        tags.forEach(tag => {
                            if (tag.Id === resourceTagId) {
                                this.assignedTags.push(tag);
                                this.assignedTags.sort((tag1: ITag, tag2: ITag) => { return tag1.Position - tag2.Position; });
                            }
                        });
                    });
                }

                this.assignedTags = this.deDupeTags(this.assignedTags);

                if (this.max) {
                    this.assignHiddenTags();
                }

                this.allTags = tags;
            })
            .catch(e => {
                console.error(e)
            });
    }

    private updateTags() {
        if (!this.resource) {
            return;
        }

        this.resource.TagIds = [];

        this.assignedTags.forEach(tag => {
            this.resource.TagIds.push(tag.Id);
        });
    }

    private deDupeTags(tags: ITag[]): ITag[] {
        var deDupedTags: ITag[] = [];

        tags.filter(t => t.AutoTag).forEach(t => {
            deDupedTags.push(t);
        });

        tags.filter(t => !t.AutoTag).forEach(t => {
            if (!deDupedTags.find(npTag => t.Name == npTag.Name)) {
                deDupedTags.push(t);
            }
        });

        return deDupedTags;
    }

    private assignHiddenTags() {
        this.hiddenTags = [];

        if (this.max > this.assignedTags.length) {
            return;
        }

        this.hiddenTags = angular.copy(this.assignedTags.splice(1, this.assignedTags.length - this.max));

        if (this.hiddenTags.length >= 1) {
            var hiddenTagCount = {
                Name: `+ ${this.hiddenTags.length}`,
                ResourceType: ResourceType.Geofence,
                Position: 100,
                ResourceAllocation: 3
            }

            this.assignedTags.push(hiddenTagCount);
        }

        this.tooltipLabel = '';
        this.tooltipLabel += this.assignedTags[0].Name;
        this.hiddenTags.forEach(tag => this.addTagToTooltip(tag));
    }

    private addTagToTooltip(tag: ITag) {
        if (!tag) {
            return;
        }

        if (this.tooltipLabel && this.tooltipLabel.length != 0) {
            this.tooltipLabel += ", ";
        }

        this.tooltipLabel += tag.Name;
    }
}

export class TagsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            resource: "<",
            editMode: "<",
            resourceType: "<",
            max: "@",
            onChange: '&',
            onTagDeleted: '&'
        };

        this.controller = TagsComponentController;
        this.template = require("./tags.html");
    }
}
